import React from "react";
import backgroundImage from "../../assets/about-us-banner.png";

const AboutBanner = () => {
  return (
    <div
      className="bg-cover bg-center my-8 mx-6 rounded-3xl h-[210px] sm:h-[300px] md:h-[70vh] lg:h-[500px]"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      {/* Container for the text elements */}
        {/* Top Section: Heading, Subheading and Sign Up Button */}
      <div className="h-full flex flex-col justify-center">
        <h1 className="font-bold text-white text-center text-3xl sm:text-4xl md:text-5xl">About Us</h1>
        <div className="border-b-4 border-white-500 w-36 sm:48 md:w-64 mx-auto mt-5"></div> 
      </div>
    </div>
  );
};

export default AboutBanner;

